import React from "react";
import { useNavigate } from "react-router-dom";
import handleUserNavigation from "../components/layouts/handleNavigation";
import Iconfoundation from "../resources/Iconfoundation.svg";
import { useTranslation } from "react-i18next";

const Foundation = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    return (
        <div>
            <button className="landing-page-buttons" onClick={()=>{handleUserNavigation(navigate, "/", "/admin/foundation/administrator-management")}}>
              <img
                    src={Iconfoundation}
                    alt="Foundation Icon"
                    width={80}
                    height={80}
                />
            </button>
            <div className="button-label">{t("foundation")}</div>
        </div>
    );
};

export default Foundation;
